import { addDays, addHours, addMinutes, addWeeks, formatISO, isBefore, parseJSON, startOfWeek } from 'date-fns';
import { format, formatInTimeZone } from 'date-fns-tz';
import { useContext } from 'react';
import { CalenderContext, CalenderContextType } from './CalenderContext';
import CalenderTitle from './CalenderTitle';
import TimeCell from './TimeCell';
import WeekChanger from './WeekChanger';
import { useAppSelector } from '../../hooks/useRedux';
import { CheckBox } from '@wot/components';
import { ISessionCategory, ISessionStatus, ISessionType } from '@wot/typings';
export interface ITimeSlot {
  start: string;
  end: string;
}
const TIMES = [
  '12:00 AM',
  '1:00 AM',
  '2:00 AM',
  '3:00 AM',
  '4:00 AM',
  '5:00 AM',
  '6:00 AM',
  '7:00 AM',
  '8:00 AM',
  '9:00 AM',
  '10:00 AM',
  '11:00 AM',
  '12:00 PM',
  '1:00 PM',
  '2:00 PM',
  '3:00 PM',
  '4:00 PM',
  '5:00 PM',
  '6:00 PM',
  '7:00 PM',
  '8:00 PM',
  '9:00 PM',
  '10:00 PM',
  '11:00 PM'
];

interface BookedSlot {
  status: ISessionStatus;
  user: { name: string; profilePic: string };
  type: ISessionType;
  category: ISessionCategory;
  slot: {
    start: string;
    end: string;
  };
}

export default function Calender({
  slotSelectable = false,
  onSelectSlot,
  selectedSlots,
  availableSlots,
  bookedSlots,
  recurrence = false,
  onReccurence
}: {
  bookedSlots?: BookedSlot[];
  availableSlots?: any[];
  selectedSlots?: any[];
  onSelectSlot?: any;
  children?: JSX.Element;
  trainerSlots?: any[];
  slotSelectable?: boolean;
  recurrence?: boolean;
  onReccurence?: any;
}) {
  const { today } = useContext(CalenderContext) as CalenderContextType;
  const { timezone } = useAppSelector((state) => state.preferencesSlice);

  return (
    <div className="w-full h-full grow flex flex-col gap-4">
      <div className="w-full flex items-center justify-between py-2">
        <CalenderTitle />
        {recurrence && (
          <div className="flex items-center gap-4">
            <CheckBox
              onChange={(checked) => {
                if (!selectedSlots) {
                  return;
                }
                if (!checked) {
                  let currentWeek = format(today, 'w');
                  let temp = selectedSlots?.filter((item) => format(parseJSON(item.start), "w") <= currentWeek);
                  onReccurence(temp);
                  return;
                }
                let temp: any[] = [];
                let currWeekSlots: ITimeSlot[] = [];
                let weekNO = format(today, 'w');
                selectedSlots.forEach((item) => {
                  if (format(parseJSON(item.start), 'w') === weekNO) {
                    currWeekSlots.push(item);
                  }
                });
                let weeks = [...new Array(51)];
                weeks.forEach((_, week) => {
                  currWeekSlots.forEach((item) => {
                    if (temp.length < 52) {
                      temp.push({
                        start: new Date(formatISO(parseJSON(addWeeks(parseJSON(item.start), week + 1)))).toISOString(),
                        end: new Date(formatISO(parseJSON(addWeeks(parseJSON(item.end), week + 1)))).toISOString()
                      });
                    }
                  });
                });
                if (selectedSlots) {
                  onReccurence([...selectedSlots, ...temp]);
                } else {
                  onReccurence([...temp]);
                }
              }}
            />
            <p className="text-sm font-medium">Repeat Every Week</p>
          </div>
        )}
      </div>
      <WeekChanger />
      <div className="w-full flex gap-5 items-center justify-center py-2">
        <div className="flex items-center gap-2">
          <div className="w-4 h-4 bg-[#9AD366] p-2 rounded-full"></div>
          <h4 className="text-sm font-normal">Available</h4>
        </div>
        <div className="flex items-center gap-2">
          <div className="w-4 h-4 bg-[#C4C4C4] p-2 rounded-full"></div>
          <h4 className="text-sm font-normal">Not Available</h4>
        </div>
        <div className="flex items-center gap-2">
          <div className="w-4 h-4 bg-secondary p-2 rounded-full"></div>
          <h4 className="text-sm font-normal">Selected</h4>
        </div>
      </div>
      <div className="w-full grow max-h-[450px] bg-white flex border rounded-md overflow-hidden overflow-y-scroll overflow-x-scroll custom-scrollbar">
        <div className="w-max max-w-[170px] flex flex-col">
          <div className="sticky top-0 w-full p-4 flex bg-gray-100 items-center justify-center basis-0 grow border">
            <p className="text-sm whitespace-nowrap">{format(today, 'xxx', { timeZone: timezone })}</p>
          </div>
          {TIMES.map((time, hour) => (
            <TimeCell text={time} key={hour} />
          ))}
          <div className="w-full h-10 px-4 flex flex-col bg-white items-center justify-center border shrink-0">
            <p className="text-sm whitespace-nowrap">12:00 AM</p>
          </div>
        </div>

        <div className="w-full h-full flex">
          <div className="w-full h-full flex items-center">
            {[...new Array(7)].map((_, weekNo) => (
              <div className="w-full h-full flex flex-col" key={weekNo}>
                <div className="min-w-[70px] sticky top-0 z-50 p-4 flex bg-gray-100 items-center justify-center basis-0 grow border">
                  {/* <p className="text-sm">{formatInTimeZone(addDays(startOfWeek(today), weekNo), timezone, 'eee d')}</p> */}
                  <p className="text-sm whitespace-nowrap">{format(addDays(startOfWeek(today), weekNo), 'eee d')}</p>
                </div>
                <div className="relative w-full h-full flex flex-col">
                  {slotSelectable
                    ? TIMES.map((_, hour) => (
                      <div className="w-full h-20 shrink-0 z-30" key={hour}>
                        <SelectableSlots
                          selectedSlots={selectedSlots}
                          availableSlots={availableSlots}
                          onSelectSlot={onSelectSlot}
                          time={format(
                            addHours(addDays(startOfWeek(today), weekNo), hour),
                            'yyyy-MM-dd HH:mm:ssXXX',
                            { timeZone: timezone }
                          )}
                        />
                      </div>
                    ))
                    : TIMES.map((_, hour) => {
                      let time = format(
                        addHours(addDays(startOfWeek(today), weekNo), hour),
                        'yyyy-MM-dd HH:mm:ssXXX',
                        { timeZone: timezone }
                      );
                      return (
                        <div className="w-full h-20 shrink-0" key={hour}>
                          <div
                            className={`relative w-full h-full border border-collapse border-spacing-0 z-10 ${isBefore(
                              new Date(time),
                              new Date(formatInTimeZone(new Date(), timezone, 'yyyy-MM-dd HH:mm:ssxxx'))
                            )
                              ? 'bg-gray-300'
                              : 'bg-transparent'
                              }`}
                          >
                            <div className="w-full h-1/2"></div>
                            <div className="w-full h-1/2 border-t"></div>
                          </div>
                        </div>
                      );
                    })}
                  {availableSlots &&
                    availableSlots?.length > 0 &&
                    availableSlots.map((slot) => (
                      <AvailableSlots
                        key={slot.start}
                        slot={slot}
                        time={format(addDays(startOfWeek(today), weekNo), 'yyyy-MM-dd HH:mm:ssXXX', {
                          timeZone: timezone
                        })}
                      />
                    ))}
                  {bookedSlots &&
                    bookedSlots?.length > 0 &&
                    bookedSlots.map((slot) => (
                      <BookedSlots
                        key={slot.slot.start}
                        session={slot}
                        time={format(addDays(startOfWeek(today), weekNo), 'yyyy-MM-dd HH:mm:ssXXX', {
                          timeZone: timezone
                        })}
                      />
                    ))}
                  {selectedSlots &&
                    selectedSlots?.length > 0 &&
                    selectedSlots.map((slot) => (
                      <SelectedSlots
                        key={slot.start}
                        onSelectSlot={() => onSelectSlot(slot, 1)}
                        slot={slot}
                        time={format(addDays(startOfWeek(today), weekNo), 'yyyy-MM-dd HH:mm:ssXXX', {
                          timeZone: timezone
                        })}
                      />
                    ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

function positionSlot(slot: any, time: string) {
  const { timezone } = useAppSelector((state) => state.preferencesSlice);
  let steps = 2;
  let hour = Number(formatInTimeZone(new Date(slot.start), timezone, 'H'));
  let minutes = Number(formatInTimeZone(new Date(slot.start), timezone, 'm'));
  let height = 40;
  let top = minutes === 0 ? hour * steps * height : (hour * steps + 1) * height;
  let exists =
    formatInTimeZone(parseJSON(time), timezone, 'd/L/y') === formatInTimeZone(parseJSON(slot.start), timezone, 'd/L/y');
  return { exists, top };
}

function SelectableSlots({
  time,
  onSelectSlot
}: {
  time: string;
  onSelectSlot: any;
  selectedSlots: any;
  availableSlots: any;
}) {
  const sessionDuration = 60;
  const { timezone } = useAppSelector((state) => state.preferencesSlice);

  const onClick = (time: string) => {
    // 1. return if time is before current time
    if (isBefore(new Date(time), new Date(formatInTimeZone(new Date(), timezone, 'yyyy-MM-dd HH:mm:ssxxx')))) {
      return;
    }

    // create timeslot in utc
    const timeslot = {
      start: new Date(time).toISOString(),
      end: new Date(formatISO(addMinutes(parseJSON(time), sessionDuration))).toISOString()
    };
    // 2. if availble slots and time is not in available slot return;
    // if (availableSlots.length > 0) {
    //   let slot = _.find(availableSlots, (o) => { return _.isMatch(o, timeslot) });
    //   if (!slot) return;
    // }
    // TODO: overlapping slots
    onSelectSlot(timeslot);
  };
  return (
    <div
      className={`relative w-full h-full ${isBefore(new Date(time), new Date(formatInTimeZone(new Date(), timezone, 'yyyy-MM-dd HH:mm:ssxxx')))
        ? 'bg-gray-300'
        : 'bg-transparent'
        } border border-collapse border-spacing-0 z-20`}
    >
      <div onClick={() => onClick(time)} className="w-full h-1/2"></div>
      <div onClick={() => onClick(formatISO(addMinutes(parseJSON(time), 30)))} className="w-full h-1/2 border-t"></div>
    </div>
  );
}

function AvailableSlots({ slot, time }: { slot: any; time: string }) {
  const { top, exists } = positionSlot(slot, time);
  if (!exists) {
    return null;
  }
  return (
    <div
      style={{ top: top }}
      className={`w-full flex flex-col p-1 absolute left-0 h-20 bg-green-300 z-20 border`}
    ></div>
  );
}

function SelectedSlots({ slot, time, onSelectSlot }: { slot: any; time: string; onSelectSlot: any }) {
  const { top, exists } = positionSlot(slot, time);
  if (!exists) {
    return null;
  }
  return (
    <div
      onClick={() => onSelectSlot()}
      style={{ top: top }}
      className={`w-full flex flex-col p-1 absolute left-0  cursor-pointer h-20 bg-orange-300 z-30 border`}
    ></div>
  );
}

function BookedSlots({ session, time }: { session: BookedSlot; time: string }) {
  const { top, exists } = positionSlot(session.slot, time);
  if (!exists) {
    return null;
  }

  return (
    <div
      style={{ top: top }}
      className={`w-full flex flex-col p-1 absolute left-0 h-20 bg-neutralBlue2 z-40 border-l-4 rounded-md
    ${session.status === 'upcoming'
          ? ' border-[#2AB3BB]'
          : session.status === 'completed'
            ? 'border-[#9AD366]'
            : session.status === 'cancelled'
              ? 'border-[#FB8F8C]'
              : ''
        }
    `}
    >
      <p className="text-base font-medium">{session && session.user && session.user.name}</p>
      <p className="text-xs md:text-sm">{session.category.name}</p>
    </div>
  );
}
